"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[842],{

/***/ 14311:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j": function() { return /* reexport */ MobileNavInfo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@wartek-id/icon/dist/index.esm.js + 66 modules
var index_esm = __webpack_require__(87791);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js
var dist_index_esm = __webpack_require__(73041);
;// CONCATENATED MODULE: ./components/MobileNavInfo/MobileNavInfo.tsx



var MobileNavInfo = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "w-full p-4 bg-surface-informational-subdued flex items-center space-x-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Icon */.J, {
                    as: "i",
                    fontSize: "small",
                    color: "informational",
                    children: "desktop_windows"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                    variant: "body-sm",
                    className: "!font-bold",
                    children: "Gunakan komputer/laptop untuk menavigasi Ruang Kolaborasi dengan lebih mudah."
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/MobileNavInfo/index.ts



/***/ }),

/***/ 84394:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* reexport */ Modal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-modal/lib/index.js
var lib = __webpack_require__(83253);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(17428);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js
var dist_index_esm = __webpack_require__(73041);
;// CONCATENATED MODULE: ./public/icon/close.svg
/* harmony default export */ var icon_close = ({"src":"/_next/static/media/close.aba5a33d.svg","height":14,"width":14});
;// CONCATENATED MODULE: ./components/Modal/Modal.tsx











var customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        maxHeight: "90vh",
        overflow: "auto",
        padding: "12px"
    },
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.75)",
        zIndex: 999
    }
};
function Modal(_param) {
    var children = _param.children, className = _param.className, isOpen = _param.isOpen, onClose = _param.onClose, _shouldCloseOnOverlayClick = _param.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? true : _shouldCloseOnOverlayClick, _title = _param.title, title = _title === void 0 ? "Modal Title" : _title, fullHeight = _param.fullHeight, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "isOpen",
        "onClose",
        "shouldCloseOnOverlayClick",
        "title",
        "fullHeight"
    ]);
    var closeModal = function() {
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((lib_default()), {
            isOpen: isOpen,
            style: customStyles,
            contentLabel: title,
            onRequestClose: closeModal,
            shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
            ariaHideApp: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: className,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(fullHeight && "h-full", "p-2"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "grid grid-cols-12 gap-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-10 flex flex-col",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Text */.x, {
                                        color: "default",
                                        variant: "heading-lg",
                                        className: "mb-2",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-span-2 text-right",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex justify-end",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Button */.z, {
                                            onClick: closeModal,
                                            size: "sm",
                                            variant: "ghost",
                                            className: "!p-3",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: icon_close,
                                                width: 14,
                                                height: 14,
                                                alt: "Icon Close"
                                            })
                                        })
                                    })
                                })
                            ]
                        }),
                        children
                    ]
                })
            })
        })
    }));
}

;// CONCATENATED MODULE: ./components/Modal/index.ts



/***/ }),

/***/ 48842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LoginFooter": function() { return /* binding */ LoginFooter; },
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@wartek-id/button/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(17428);
// EXTERNAL MODULE: ./node_modules/@wartek-id/spinner/dist/index.esm.js
var dist_index_esm = __webpack_require__(54764);
// EXTERNAL MODULE: ./node_modules/@wartek-id/text/dist/index.esm.js
var text_dist_index_esm = __webpack_require__(73041);
// EXTERNAL MODULE: ./node_modules/@wartek-id/toast/dist/index.esm.js
var toast_dist_index_esm = __webpack_require__(42356);
// EXTERNAL MODULE: ./configs/auth.ts
var auth = __webpack_require__(32178);
// EXTERNAL MODULE: ./configs/routes/index.ts
var routes = __webpack_require__(70066);
// EXTERNAL MODULE: ./components/MobileNavInfo/index.ts + 1 modules
var MobileNavInfo = __webpack_require__(14311);
// EXTERNAL MODULE: ./node_modules/@wartek-id/separator/dist/index.esm.js
var separator_dist_index_esm = __webpack_require__(49168);
// EXTERNAL MODULE: ./components/Modal/index.ts + 2 modules
var Modal = __webpack_require__(84394);
;// CONCATENATED MODULE: ./app/Login/components/ErrorModal/ErrorModal.tsx




var ErrorModal = function(param) {
    var data = param.data, isOpen = param.isOpen, onClose = param.onClose, onRelogin = param.onRelogin;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
        isOpen: isOpen,
        onClose: onClose,
        title: "Akun Belum Terdaftar",
        className: "w-full md:w-[500px]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mb-8",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                        color: "subdued",
                        variant: "body",
                        children: "Berikut yang bisa Anda lakukan:"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border border-gray-30 rounded-full w-8 h-8 flex justify-center items-center",
                                children: "1"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-3",
                                    children: "Pastikan Anda masuk dengan Akun Google, atau dengan alamat email yang Anda gunakan untuk masuk ke platform Merdeka Mengajar."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-primary font-semibold cursor-pointer",
                                        onClick: function() {
                                            return onRelogin(data === null || data === void 0 ? void 0 : data.provider);
                                        },
                                        children: "Coba masuk lagi"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(separator_dist_index_esm/* Separator */.Z, {
                    className: "my-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border border-gray-30 rounded-full w-8 h-8 flex justify-center items-center",
                                children: "2"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-3",
                                    children: "Jika Anda adalah Kontributor Perangkat Ajar, pastikan Anda menggunakan alamat email yang sudah didaftarkan ke Ruang Kolaborasi."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-primary font-semibold cursor-pointer",
                                        href: "https://ruangkolaborasi.zendesk.com/hc/en-us/articles/5011014888473-Alur-pendaftaran",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "Lihat cara daftar"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(separator_dist_index_esm/* Separator */.Z, {
                    className: "my-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex space-x-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex justify-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border border-gray-30 rounded-full w-8 h-8 flex justify-center items-center",
                                children: "3"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-3",
                                    children: "Jika Anda yakin email Anda sudah benar namun tetap tidak bisa masuk, mohon hubungi bantuan."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "text-primary font-semibold cursor-pointer",
                                        href: "https://ruangkolaborasi.zendesk.com/hc/en-us",
                                        children: "Hubungi Bantuan"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./app/Login/components/ErrorModal/index.ts


;// CONCATENATED MODULE: ./app/Login/constants/index.ts
var ERROR_MESSAGES = {
    NetworkError: "Koneksi internet anda error, coba lagi dalam beberapa saat",
    SessionExpired: "Sesi berakhir sehingga Anda keluar otomatis. Silakan masuk lagi."
};

// EXTERNAL MODULE: ./utils/hooks/useAsync.ts
var useAsync = __webpack_require__(52778);
// EXTERNAL MODULE: ./utils/hooks/useReferrer.ts
var useReferrer = __webpack_require__(45699);
// EXTERNAL MODULE: ./utils/auth.ts
var utils_auth = __webpack_require__(92601);
// EXTERNAL MODULE: ./utils/cookie.ts + 1 modules
var cookie = __webpack_require__(23928);
// EXTERNAL MODULE: ./stores/authError.ts + 1 modules
var authError = __webpack_require__(16374);
;// CONCATENATED MODULE: ./pages/login.tsx





















var FOOTER_LINKS = [
    {
        title: "Panduan dan Bantuan",
        target: "https://ruangkolaborasi.zendesk.com/hc/en-us"
    },
    {
        title: "Kebijakan Privasi",
        target: "/privacy-policy"
    },
    {
        title: "Syarat & Ketentuan",
        target: "/terms-conditions"
    }, 
];
// interface LoginProps {
//   referrer: string | null
// }
// export async function getServerSideProps(context) {
//   return {
//     props: {
//       referrer: context?.req?.headers?.referer ?? null,
//     },
//   }
// }
var LoginFooter = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex-grow-0 mt-12 mb-4 flex-wrap flex justify-center md:justify-between",
        children: FOOTER_LINKS.map(function(link, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mx-4 md:mx-0 mb-2 md:mb-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: link.target,
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        target: "_blank",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                            variant: "body-sm",
                            className: "!font-bold",
                            children: link.title
                        })
                    })
                })
            }, "login-footer-link-".concat(index));
        })
    });
};
var Login = function() {
    var toast = (0,toast_dist_index_esm/* useToast */.pm)();
    var setReferrer = (0,useReferrer/* useReferrer */.W)().setReferrer;
    var ref = (0,react.useState)(), providers = ref[0], setProviders = ref[1];
    var ref1 = (0,react.useState)(false), isErrorModalOpen = ref1[0], setErrorModalOpen = ref1[1];
    var ref2 = (0,useAsync/* useAsync */.r)(), status = ref2.status, data = ref2.data, run = ref2.run, reset = ref2.reset;
    var ref3 = (0,react.useState)(null), flashAuthError = ref3[0], setFlashAuthError = ref3[1];
    var ref4 = (0,authError/* useAuthErrorStore */.P)(), persistedAuthError = ref4.authError, hasAuthError = ref4.hasAuthError, setPersistedAuthError = ref4.setAuthError;
    var title = "Masuk Ruang Kolaborasi Merdeka Mengajar";
    var description = "Pusat pengelolaan konten dan pengguna platform Merdeka Mengajar.";
    var fetchProviders = (0,react.useCallback)(function() {
        run((0,next_auth_react.getProviders)());
    }, [
        run
    ]);
    var errorModalClosedHandler = function() {
        setErrorModalOpen(false);
        setFlashAuthError(null);
    };
    (0,react.useEffect)(function() {
        if (!data) {
            fetchProviders();
        }
    }, [
        data,
        fetchProviders
    ]);
    (0,react.useEffect)(function() {
        if (status === "success" && data) {
            setProviders(data);
        }
        if (status === "error") {
            setProviders(null);
            reset();
        }
    }, [
        data,
        status,
        reset
    ]);
    (0,react.useEffect)(function() {
        if (hasAuthError()) {
            var authError = persistedAuthError;
            setFlashAuthError(authError);
            setPersistedAuthError();
            if ((authError === null || authError === void 0 ? void 0 : authError.type) === "NotRegistered") {
                setErrorModalOpen(true);
            } else {
                toast({
                    message: ERROR_MESSAGES[authError === null || authError === void 0 ? void 0 : authError.type]
                });
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        hasAuthError
    ]);
    (0,react.useEffect)(function() {
        // if (referrer) {
        // const url = new URL()
        // const referrerPath = url.pathname.replace(
        //   process.env.NEXT_PUBLIC_BASE_PATH,
        //   ''
        // )
        var referrerPath = "";
        if ((0,_to_consumable_array/* default */.Z)(routes/* UNPROTECTED_ROUTES */.F).concat([
            "/validate-session"
        ]).includes(referrerPath)) {
            setReferrer("");
            return;
        }
        setReferrer(referrerPath);
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = (0,utils_auth/* getTokenData */.wl)()) === null || ref === void 0 ? void 0 : ref.guruToken) {
            (0,utils_auth/* destroyTokenData */.rw)();
        }
        (0,cookie/* removeCookie */.nJ)(auth/* REGISTRATION_TYPE_STORAGE_KEY */.H);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col h-screen w-full justify-center px-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "fixed top-0 left-0 w-full z-50 block sm:hidden",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNavInfo/* MobileNavInfo */.j, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-full h-screen md:h-full flex flex-col justify-between",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-grow md:flex-0 flex flex-col justify-center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-grow-0 bg-white rounded-md p-4 py-14 md:p-16 mt-12 sm:mt-8 md:mt-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/logo.svg",
                                                alt: "Ruang Kolaborasi Merdeka Mengajar Logo",
                                                width: 600,
                                                height: 177
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-9 mx-auto",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_dist_index_esm/* Text */.x, {
                                                variant: "body-lg",
                                                children: description
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                !providers && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Spinner */.$, {
                                                        size: "lg"
                                                    })
                                                }),
                                                providers && Object.values(providers).map(function(provider) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Button */.z, {
                                                            color: "blue",
                                                            variant: "solid",
                                                            size: "sm",
                                                            className: "!py-2 !px-8 !flex !justify-between",
                                                            onClick: function() {
                                                                return (0,next_auth_react.signIn)(provider.id);
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "/images/logo-kemdikbud.png",
                                                                    alt: "Kemdikbud Logo",
                                                                    width: 32,
                                                                    height: 32,
                                                                    className: "flex-grow-0"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "ml-2 px-6 flex-grow",
                                                                    children: [
                                                                        "Masuk dengan ",
                                                                        provider.name
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }, provider.name);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorModal, {
                data: flashAuthError,
                isOpen: isErrorModalOpen,
                onClose: errorModalClosedHandler,
                onRelogin: function(provider) {
                    return (0,next_auth_react.signIn)(provider);
                }
            })
        ]
    });
};
/* harmony default export */ var login = (Login);


/***/ }),

/***/ 52778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useAsync; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useAsync() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("idle"), status = ref[0], setStatus = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), data = ref1[0], setValue = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), error = ref2[0], setError = ref2[1];
    var run = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(promiseObject) {
        setStatus("loading");
        setValue(null);
        setError(null);
        return promiseObject.then(function(response) {
            setValue(response);
            setStatus("success");
        }).catch(function(error) {
            setError(error);
            setStatus("error");
        });
    }, []);
    var reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        setStatus("idle");
        setError(null);
    }, []);
    return {
        run: run,
        reset: reset,
        status: status,
        data: data,
        error: error
    };
}


/***/ }),

/***/ 45699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useReferrer; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);

var REFERRER_STORAGE_KEY = "guru-cms-referrer";
var useReferrer = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var setReferrer = function(value) {
        window.localStorage.setItem(REFERRER_STORAGE_KEY, value);
    };
    var redirectToReferrer = function(fallbackValue) {
        var referrer = window.localStorage.getItem(REFERRER_STORAGE_KEY);
        if (!!referrer) {
            window.localStorage.removeItem(REFERRER_STORAGE_KEY);
            router.replace(referrer);
            return;
        }
        router.replace(fallbackValue);
    };
    return {
        setReferrer: setReferrer,
        redirectToReferrer: redirectToReferrer
    };
};


/***/ })

}]);